const State = {
  balanceOfPaymentList: []
}

export default State
